<template>
  <li>
    <div class="card bg-white border mb-2 hover px-2">
      <div class="d-flex align-items-start justify-content-between flex-grow-1 flex-sm-nowrap flex-wrap">
        <div class="mr-2">
          <span class="pr-1 count">
            {{ positionInArray }}
          </span>
          <item-details-link
            class="ml-1"
            :position="course.course_name"
            target="_blank"
            @click.native="handleCourseLink"
          />
        </div>
      </div>

      <div class="col-12 px-2 pb-2">
        <span class="mr-2">{{ course.start_date }}</span>
        {{ course.location }} - {{ course.course_provider }}
        <div v-if="isShowLocationMarker" class="d-inline ml-2 text-nowrap">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-arrow-left-right distance__icon"
          >
            <path
              fill-rule="evenodd"
              d="M1 11.5a.5.5 0 0 0 .5.5h11.793l-3.147 3.146a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 11H1.5a.5.5 0 0 0-.5.5zm14-7a.5.5 0 0 1-.5.5H2.707l3.147 3.146a.5.5 0 1 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 4H14.5a.5.5 0 0 1 .5.5z"
            />
          </svg>

          {{ course.distance }}
        </div>
      </div>
    </div>

  </li>
</template>

<script lang="ts">
import { ICourse } from '@/types/courses/Courses';
import { Component, Vue, Prop } from 'vue-property-decorator';

// TODO: rename and meka template of it/set click on link;
import ItemDetailsLink from '@/components/Courses/Modal/ItemDetailsLink.vue';

@Component({
  components: {
    'item-details-link': ItemDetailsLink,
  },
})
export default class CourseItem extends Vue {
  @Prop({ required: true }) course!: ICourse;

  @Prop({ required: true }) positionInArray!: number;

  isDisabled = false;

  handleCourseLink() {
    this.$emit('handle-click');
  }

  get isShowLocationMarker() {
    return this.course.distance && this.course.location !== 'Bundesweit';
  }
}
</script>

<style lang="scss" scoped>
.count {
  min-width: 35px;
}

.distance {
  &__icon {
    color: var(--global-second-color-80);
  }
}
</style>
